import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
 // Assurez-vous que le chemin d'importation est correct
import { useAuthContext } from "@/context/AuthContext"

    ;
export const DELETE_SKILL = gql`
  mutation DeleteSkill($uuid: ID!) {
    deleteSkill(uuid: $uuid)
  }
`;


export const useDeleteSkill = () => {
  const [deleteSkillMutation, { loading, error, data }] = useMutation(
    DELETE_SKILL
  );

  const deleteSkill = async (uuid) => {
    try {
      const response = await deleteSkillMutation({
        variables: { uuid },
      });
      return response.data.deleteSkill;
    } catch (err) {
      throw new Error(err.message);
    }
  };

  return { deleteSkill, loading, error, data };
};
